import { dataStorageKeywords, userRoles } from 'src/utils/properties.utils';
import { getEncryptedLocalStorageData } from 'src/utils/dataStorageManagement.utils';

export const fetchCurrentUserRole = async () => {
  const role = await getEncryptedLocalStorageData(
    dataStorageKeywords.HIGHEST_ROLE
  );
  return role === userRoles.OWNER;
};
